import React from 'react';

import Card from 'components/Cards/DataCardHotels';
import { HotelsResultResponse } from 'models/hotelsSearch';

import { Container, Wrapper } from './styles';

interface Props {
  data?: HotelsResultResponse;
  show: boolean;
  onClick: () => void;
}

export const FloatingCard = ({ data, show, onClick }: Props) => (
  <Container isVisible={show}>
    <Wrapper>{data && <Card data={data} onClick={onClick} />}</Wrapper>
  </Container>
);

export default FloatingCard;
